import { useQuery, useQueryClient, useMutation } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useInvoiceNoteTemplates = (config) => {
  return useQuery({
    ...config,
    queryKey: "invoice-note-templates",
    queryFn: ({ signal }) =>
      fetch({
        url: `${Angie.api_url}/invoice-note-templates`,
        signal,
      }),
  });
};

export const useCreateNoteTemplate = () => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/invoice-note-templates`,
        method: "POST",
        body: data,
      }),
    onSuccess: (response) => {
      const previous = client.getQueryData("invoice-note-templates") || [];
      client.setQueryData("invoice-note-templates", [...previous, response.single]);
    },
  });
};

export const useUpdateNoteTemplate = (id) => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (data) =>
      fetch({
        url: `${Angie.api_url}/invoice-note-templates/${id}`,
        method: "PUT",
        body: data,
      }),
    onSuccess: () => {
      client.invalidateQueries("invoice-note-templates");
    },
  });
};

export const useDeleteNoteTemplate = () => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (id) =>
      fetch({
        url: `${Angie.api_url}/invoice-note-templates/${id}`,
        method: "DELETE",
      }),
    onMutate: (id) => {
      const previous = client.getQueryData("invoice-note-templates") || [];
      client.setQueryData(
        "invoice-note-templates",
        previous.filter((item) => item.id !== id)
      );
    },
    onSuccess: () => {
      client.invalidateQueries("invoice-note-templates");
    },
  });
};
